import {BehaviorSubject} from 'rxjs';
import {filter} from 'rxjs/operators';
import {wwData$} from './worker-data';

const win = window;

export const network$ = new BehaviorSubject({
  online: win.navigator.onLine,
  delay: 0,
  lastTime: Date.now(),
});

win.addEventListener('online', updateOnlineStatus);
win.addEventListener('offline', updateOnlineStatus);

wwData$.pipe(filter((o) => o.type === 'network-delay')).subscribe(({data: {delay}}) => network$.next({...network$.getValue(), delay}));

wwData$.pipe(filter((o) => o.type === 'network-last-time')).subscribe(({data: {lastTime}}) => network$.next({...network$.getValue(), lastTime}));

function updateOnlineStatus() {
  const online = win.navigator.onLine;
  network$.next({...network$.getValue(), online});
}
